import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import Category from './views/Category'
import Tag from './views/Tag'
import Author from './views/Author'
import Post from './views/Post'
//import Prueba from './views/Prueba'
import Page from './views/Page'
import QuienesSomos from './views/QuienesSomos'
import Ciudad from './views/Ciudad'
import SearchResults from './views/SearchResults'
import Home from './components/Home'
//import VueSanitize from "vue-sanitize"
import VueSanitize from 'vue-sanitize-directive'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueRouter);

const routes = [
    { path: '/', name: 'home', component: Home },
    { path: '/:postSlug', name: 'post', component: Post },
    {
      path: '/author/:authorId',
      name: 'author',
      component: Author
    },
    {
      path: '/c/:categorySlug+',
      name: 'category',
      component: Category,
      props: route => ({
        categorySlug: route.params.categorySlug.split('/')
      })
    },
    {
      path: '/t/:tagSlug/',
      name: 'tag',
      component: Tag
    },
    {
      path: '/p/quienes-somos',
      name: 'quienessomos',
      component: QuienesSomos
    },
    {
      path: '/p/conservacion-e-investigacion',
      name: 'conservacion',
      component: Page
    },
    {
      path: '/p/ejes-tematicos',
      name: 'ejes',
      component: Page
    },
    {
      path: '/p/sala-cortina',
      name: 'salacortina',
      component: Page
    },
    {
      path: '/p/contacto',
      name: 'contacto',
      component: Page
    },
    {
      path: '/p/archivo',
      name: 'archivo',
      component: Page
    },
    {
      path: '/p/ciudad-vivida',
      name: 'ciudadvivida',
      component: Ciudad
    },
    {
      path: '/s/:searchText',
      name: 'searchresults',
      component: SearchResults
    }
];


const router = new VueRouter({
  routes,
  mode: 'history'
});

Vue.use(VueSanitize);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
